{
  "info": "Informações",
  "negative": "Erro",
  "notice": "Aviso",
  "positive": "Sucesso"
}
